import { render, staticRenderFns } from "./ZKFPZ.vue?vue&type=template&id=0979b460&scoped=true"
import script from "./ZKFPZ.vue?vue&type=script&lang=js"
export * from "./ZKFPZ.vue?vue&type=script&lang=js"
import style0 from "./ZKFPZ.vue?vue&type=style&index=0&id=0979b460&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0979b460",
  null
  
)

export default component.exports